import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { Animations, EditorAnimationsSym } from '../symbols'
import { WixCodeSdkHandlersProviderSym } from '@wix/thunderbolt-symbols'
import { EditorAnimations, EditorAnimationsFactory } from './editorAnimations'
import { wixCodeHandlersProvider } from '../wixCode/wixCodeHandlersProvider'

export const editor: ContainerModuleLoader = (bind) => {
	bind(Animations).to(EditorAnimationsFactory)
	bind(EditorAnimationsSym).to(EditorAnimations)
	bind(WixCodeSdkHandlersProviderSym).to(wixCodeHandlersProvider)
}
